export default "__VITE_ASSET__CCEkIbGp__"